import companyListReducer from "../../slices/superAdmin/company/CompanyList"
import companyDetailsReducer from "../../slices/superAdmin/company/CompanyDetails"
import companyUserListReducer from "../../slices/superAdmin/company_user/CompanyUserList"
import companyUserDetailsReducer from "../../slices/superAdmin/company_user/CompanyUserDetails"


const superAdminReducer = {
    companyList: companyListReducer,
    companyDetails: companyDetailsReducer,
    companyUserList: companyUserListReducer,
    companyUserDetails: companyUserDetailsReducer,

}

export default superAdminReducer
